import { render } from "./ImportRole.vue?vue&type=template&id=35bd6bf0&scoped=true"
import script from "./ImportRole.vue?vue&type=script&lang=js"
export * from "./ImportRole.vue?vue&type=script&lang=js"

import "./ImportRole.vue?vue&type=style&index=0&id=35bd6bf0&scoped=true&lang=less"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bd6bf0"]])

export default __exports__